import React, { Fragment, useState, useContext, useEffect } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import {
  useAccount,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
  useNetwork,
  useSwitchNetwork,
} from "wagmi";
import { Row, Card, Col, Button, Nav, Alert, Accordion } from "react-bootstrap";
import { Stepper, Step } from "react-form-stepper";

import StepOne from "./steps/StepOne";
import StepTwo from "./steps/StepTwo";
import Topupbutton from "./Topupbutton.js";

const CardWidget = (props) => {
  //   console.log("props", props);
  const [localUser, setLocalUser] = useState(props.user || null);
  //   console.log("props.user", props.user);
  const [card_kyc_data, setcard_kyc_data] = useState(
    props.card_kyc_data || null
  );
  const [userCard, setuserCard] = useState(props.userCard || null);

  const { address, isConnecting, isDisconnected } = useAccount();
  const [goSteps, setGoSteps] = useState(0);
  const [refreshloading, setrefreshloading] = useState(false);
  const [cardBalance, setcardBalance] = useState(0);
  const [issuer_Last4, setissuer_Last4] = useState("0000");
  const [LoadAmount, setLoadAmount] = useState(0);
  const [minAmount, setminAmount] = useState(0);
  const [real_amount, setreal_amount] = useState(0);
  const [topuperror, settopuperror] = useState("");
  const [limitleft, setlimitleft] = useState(0);
  const [net_topup, setnet_topup] = useState(0);
  const [toFcf, setToFcf] = useState(0);
  const [dailytopups, setdailytopups] = useState(0);
  const [isdailylimit, setdailylimit] = useState(false);
  const [status, setStatus] = useState("");
  const [success_message, setsuccess_message] = useState(false);
  const [old_balance, set_old_balance] = useState(false);

  const [show, setShow] = useState(false);
  const [success_message_pin, setsuccess_message_pin] = useState(false);

  const loadingfees = {
    1: [0.0495, 5],
    2: [0.0395, 4],
    3: [0.0295, 3],
    10: [0, 0],
  };

  const handlerefreshbalance = async () => {
    setrefreshloading(true);
    const balance = await fetchcardbalance();
    if (balance !== cardBalance) {
      console.log("Balance changed");
      if (localUser?.cards?.bb_active == "0") {
        console.log("Card is inactive");
        const data = {
          userId: localUser.id,
        };

        fetch("https://api.bridge-bit.com/api/update_card_status", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .finally(() => {
            console.log("bb active successful DB");
            // setcard_status("1");
          });
      } else {
        console.log("Card active");
      }
      setrefreshloading(false);
      window.location.reload();
    }
    setcardBalance(balance);
    setrefreshloading(false);
  };

  //SET STEP
  useEffect(() => {
    if (userCard !== null) {
      let min_amount;
      let fix_fee;
      let real_amount;
      if (userCard?.bb_active == "0") {
        setminAmount(100);
        min_amount = 100;
        fix_fee = 20;
        real_amount = LoadAmount - fix_fee;
      } else {
        setminAmount(50);
        min_amount = 50;
        fix_fee = 0;
        real_amount = LoadAmount;
      }

      setrefreshloading(true);
      console.log("fetching Balance");
      console.log(userCard);
      console.log("userCard.length", userCard.length);
      if (userCard) {
        const fetchBalance = async () => {
          if (userCard?.cardKitNumber !== 12345) {
            console.log("fetched Balance");
            const balance = await fetchcardbalance();
            setcardBalance(balance);
            setissuer_Last4(userCard?.issuer_Last4);
            if (userCard.initial_pin === "1") {
              setGoSteps(2);
            } else {
              setGoSteps(1);
            }
            setrefreshloading(false);
          }
        };

        fetchBalance();
      } else {
        setrefreshloading(false);
      }
    }
  }, [userCard]);

  const fetchcardbalance = async () => {
    // if (userCard?.bb_active === 1) {
    console.log("userCard", userCard);
    const response = await axios.post(
      "https://dashboard.croesus-asset.management/api/physical-cards/get-balance",
      {
        card_number: userCard.cardKitNumber,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization:
            "Bearer PtuvxLhFoAAudqR13uhbDNect4UQNqD1kWDz0SYkLhQwDzNcNREgHuVLApSg",
        },
      }
    );

    if (response.data.message === "Something went wrong") {
      if (userCard) {
        return userCard.balance;
      }
    }

    if (!response.status === 200) {
      throw new Error("Network response was not ok");
    }
    console.log("balance update", response.data.message);
    return response.data.message;
    // } else {
    //   return "0.00";
    // }
  };

  const loadinglimit = {
    1: [1500],
    2: [3000],
    3: [150000],
    10: [0, 0],
  };

  const handleonPinChanged = () => {
    setShow(true);
    setsuccess_message_pin(true);
    setGoSteps(1);
  };

  const handleStatusChange = (status) => {
    // console.log("handleStatusChange", status);
    setStatus(status);
  };

  const handlesettopuperror = (message) => {
    // console.log("handleettopuperror", message);
    settopuperror(message);
  };

  const handleTopUpSuccess = async () => {
    // console.log("handleTopUpSuccess");
    setsuccess_message(true);
    set_old_balance(cardBalance);
    const interval = setInterval(() => {
      handlerefreshbalance();
    }, 15000);

    return () => clearInterval(interval);
  };

  //topup process

  useEffect(() => {
    // console.log(
    //   "localUser.transactionstopuprealtime",
    //   localUser.transactionstopuprealtime.length
    // );
    if (localUser.transactionstopuprealtime.length > 0) {
      const totalBrutAmount = localUser.transactionstopuprealtime.reduce(
        (total, transaction) => total + parseFloat(transaction.brut_amount),
        0
      );
      // console.log("Total Brut Amount:", totalBrutAmount);
      setdailytopups(totalBrutAmount);
      let dailylimit;
      if (localUser?.cards?.card_type) {
        // console.log("dailylimit", dailylimit);
        dailylimit =
          Number(loadinglimit[localUser?.cards?.card_type][0]) -
          totalBrutAmount;
        // console.log("dailylimit left", dailylimit);
      }
      setlimitleft(dailylimit);
      // console.log("dailylimit", dailylimit);
      // console.log("LoadAmount", LoadAmount);
      if (LoadAmount !== 0) {
        if (dailylimit >= LoadAmount) {
          // console.log("setdailylimit true");
          setdailylimit(true);
        }
      } else {
        if (dailylimit >= totalBrutAmount) {
          // console.log("setdailylimit true");
          setdailylimit(true);
        }
      }
    } else {
      if (localUser?.cards?.card_type) {
        setlimitleft(Number(loadinglimit[localUser?.cards?.card_type][0]));
        if (LoadAmount !== 0) {
          if (
            Number(loadinglimit[localUser?.cards?.card_type][0]) >= LoadAmount
          ) {
            // console.log("setdailylimit true");
            setdailylimit(true);
          } else {
            setdailylimit(false);
          }
        } else {
          setdailylimit(true);
        }
      }
    }
  }, [localUser, LoadAmount]);

  useEffect(() => {
    settopuperror("");
    console.log("useEffect Loadmount");
    console.log("Address", address);
    let min_amount;
    let fix_fee;
    let real_amount;
    if (localUser?.cards?.bb_active == "0") {
      setminAmount(100);
      min_amount = 100;
      fix_fee = 20;
      real_amount = LoadAmount - fix_fee;
      setreal_amount(real_amount);
    } else {
      setminAmount(50);
      min_amount = 50;
      fix_fee = 0;
      real_amount = LoadAmount;
      setreal_amount(real_amount);
    }
    if (LoadAmount >= min_amount) {
      console.log("Number(LoadAmount)", Number(LoadAmount));
      console.log("Number(limitleft)", Number(limitleft));
      if (Number(LoadAmount) > Number(limitleft)) {
        console.log("Limit exceeded");
        return;
      }

      let InputAmount = LoadAmount - fix_fee;
      console.log("InputAmount", InputAmount);

      let bridgetloadingfee =
        InputAmount * loadingfees[localUser?.cards?.card_type][0] +
        loadingfees[localUser?.cards?.card_type][1];
      console.log("bridgetloadingfee", bridgetloadingfee);

      let net_card_amount = InputAmount - bridgetloadingfee;

      console.log("net_card_amount", net_card_amount);
      //   let fcf_fee = net_card_amount * 0.0275 + 3;
      //   console.log("fcf_fee", fcf_fee);
      //   let net_card_loading_amount = net_card_amount - fcf_fee;
      //   console.log("net_card_loading_amount", net_card_loading_amount);

      //   //TOPUP SPLITTING
      //   let bb_amount = InputAmount - net_card_amount;
      //   console.log("bb_amount", bb_amount);
      //   let bb_marketing = bb_amount * 0.8;
      //   console.log("bb_marketing", bb_marketing);
      //   let bb_cr = bb_amount * 0.1;
      //   console.log("bb_cr", bb_cr);
      //   let bb_team = bb_amount * 0.1;
      //   console.log("bb_team", bb_team);
      //   let control = bb_marketing + bb_cr + bb_team;
      //   console.log("control", control);

      setnet_topup(net_card_amount.toFixed(2));
      setToFcf(net_card_amount.toFixed(2));
    } else {
    }
  }, [LoadAmount]);

  return (
    <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <div className="card">
          {goSteps === 0 ? (
            <div className="text-center">
              <Spinner />
              <h4 className="mt-2">Loading...</h4>
            </div>
          ) : (
            <>
              {userCard.bb_active == "0" && (
                <>
                  <div className="card-header">
                    <h6 className="card-title">
                      First Steps With Your Croesus Card
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="form-wizard ">
                      <Stepper
                        className="nav-wizard"
                        activeStep={goSteps}
                        label={false}
                      >
                        <Step
                          className="nav-link"
                          onClick={() => setGoSteps(1)}
                        />
                        <Step
                          className="nav-link"
                          onClick={() => setGoSteps(2)}
                        />
                        {/* <Step className="nav-link" onClick={() => setGoSteps(2)} /> */}
                      </Stepper>
                      {goSteps === 1 && (
                        <>
                          <h4 className="card-title text-center">
                            SET PERSONAL PIN
                          </h4>
                          <StepOne
                            localUser={localUser}
                            onPinChanged={handleonPinChanged}
                          />

                          {/* <div className="text-end toolbar toolbar-bottom p-2">
                      <button
                        className="btn btn-primary sw-btn-next"
                        onClick={() => setGoSteps(2)}
                      >
                        Next
                      </button>
                    </div> */}
                        </>
                      )}
                      {goSteps === 2 && (
                        <>
                          <div className="text-center mb-3">
                            <h4 className="card-title text-center">
                              INITIAL TOP UP
                            </h4>
                            <label className="text-black font-w600 ">
                              To activate your card you have to top up at least
                              $100 or more. The activation fee of 20$ will be
                              automatically substracted from your initial top
                              up.
                            </label>
                          </div>
                          <StepTwo localUser={localUser} />
                          {/* <div className="text-end toolbar toolbar-bottom p-2">
                      <button
                        className="btn btn-secondary sw-btn-prev me-1"
                        onClick={() => setGoSteps(1)}
                      >
                        Prev
                      </button>
                      <button
                        className="btn btn-primary sw-btn-next ms-1"
                        onClick={() => setGoSteps(3)}
                      >
                        Next
                      </button>
                    </div> */}
                        </>
                      )}
                      {goSteps === 3 && (
                        <>
                          {/* <StepThree /> */}
                          <div className="text-end toolbar toolbar-bottom p-2">
                            <button
                              className="btn btn-secondary sw-btn-prev me-1"
                              onClick={() => setGoSteps(2)}
                            >
                              Prev
                            </button>
                            <button
                              className="btn btn-primary sw-btn-next ms-1"
                              onClick={() => setGoSteps(3)}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="col-xl-8 col-lg-12 col-sm-12">
                  <div className="row">
                    <div className="p-0">
                      <div
                        className="card-bx "
                        style={{
                          minWidth: "270px",
                          position: "relative",
                          display: "flex",
                          zIndex: 1,
                          width: "100%",
                          marginBottom:
                            userCard.bb_active == "0" ? "80px" : "20px",
                          justifyContent: "center",
                          opacity: userCard.bb_active == "0" ? 0.3 : 1,
                        }}
                      >
                        <img
                          src="https://imagedelivery.net/0qhJEiI4Vh_ja_4EkR_5Ug/a9354c5a-e6d4-47e1-ea4b-dc3505089800/public"
                          alt=""
                          className="mw-100 "
                          style={{
                            height: "auto",
                            minHeight: "230px",
                            position: "absolute",
                            width: "100%",
                            zIndex: 0,
                            borderRadius: "0.625rem",
                            objectFit: "fill",
                          }}
                        />
                        <div
                          className="card-info text-white w-100"
                          style={{
                            position: "relative",
                            padding: "15px",
                          }}
                        >
                          <div
                            className="d-flex align-items-center mb-sm-1 mb-1"
                            style={{ justifyContent: "space-between" }}
                          >
                            <p className="mb-1">Card Balance</p>
                            {userCard.bb_active == "1" ? (
                              <p className="mb-1 text-success font-w600">
                                Active
                              </p>
                            ) : (
                              <p className="mb-1 text-danger font-w600">
                                Inactive
                              </p>
                            )}
                          </div>
                          <div
                            className="d-flex align-items-center mb-sm-1 mb-1"
                            style={{ justifyContent: "space-between" }}
                          >
                            <h2 className="fs-36 text-white mb-sm-2 mb-3">
                              {refreshloading ? (
                                <div className="loadingDots">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div>
                              ) : (
                                `$${cardBalance}`
                              )}
                            </h2>
                            <button
                              className="btn btn-light ml-2 p-2"
                              //   onClick={handlerefreshbalance}
                            >
                              <i
                                className={`fas fa-sync-alt ${
                                  refreshloading ? "fa-spin" : ""
                                }`}
                                style={{ fontSize: "25px" }}
                              ></i>
                            </button>
                          </div>

                          {LoadAmount < minAmount ? (
                            <div
                              className="d-flex align-items-center mb-sm-2 mb-2"
                              style={{ justifyContent: "space-between" }}
                            >
                              <span className="fs-14 text-danger mb-0">
                                Min. Amount {minAmount}
                              </span>

                              <h4 className="fs-20 text-white mb-0">
                                **** **** **** {issuer_Last4}
                              </h4>
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center mb-sm-2 mb-2"
                              style={{ justifyContent: "end" }}
                            >
                              <h4 className="fs-20 text-white mb-0">
                                **** **** **** {issuer_Last4}
                              </h4>
                            </div>
                          )}
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="input-group mb-3">
                              <input
                                type="text"
                                className="form-control h-auto text-black"
                                placeholder="Enter Amount"
                                onChange={(e) => setLoadAmount(e.target.value)}
                                // disabled={
                                //   isLoadingTransactionBSC ||
                                //   isLoadingTransactionMATIC
                                // }
                              />

                              <Topupbutton
                                LoadAmount={real_amount}
                                LoadAmountNet={net_topup}
                                LoadAmountFCF={toFcf}
                                onTopUpSuccess={handleTopUpSuccess}
                                onStatusChange={handleStatusChange}
                                settopuperror={handlesettopuperror}
                                dailylimitexceeded={isdailylimit}
                              />
                            </div>{" "}
                          </div>
                          <>
                            {/* {Number(LoadAmount) > Number(limitleft) && (
                          <h4 className="fs-14 text-danger mb-0">
                            Daily limit exceeded.
                          </h4>
                        )} */}

                            {/* {topuperror !== "" && (
                          <h4 className="fs-14 text-danger mb-0">
                            You don´t have enough USDT on your wallet.
                          </h4>
                        )} */}
                            {/* {maintenance !== "" && (
                          <>
                            {localUser?.settings?.BSC === 0 &&
                            localUser?.settings?.MATIC === 0 ? (
                              <>
                                <h4 className="fs-14 text-danger mb-0">
                                  {maintenance}
                                </h4>
                              </>
                            ) : (
                              <>
                                {localUser?.settings?.BSC === 0 && (
                                  <>
                                    <h4 className="fs-14 text-danger mb-0">
                                      USDT BEP20 Card loads currently
                                      unavailable due to bank maintenance. Will
                                      resume shortly.
                                    </h4>
                                  </>
                                )}
                                {localUser?.settings?.MATIC === 0 && (
                                  <>
                                    <h4 className="fs-14 text-danger mb-0">
                                      USDT MATIC Card loads currently
                                      unavailable due to bank maintenance. Will
                                      resume shortly.
                                    </h4>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )} */}
                          </>
                        </div>
                      </div>{" "}
                      {(userCard?.card_type === 1 ||
                        userCard?.card_type === 2) && (
                        <Accordion
                          className="accordion accordion-primary-solid mt-4"
                          defaultActiveKey="0"
                          style={{ maxWidth: "350px", margin: "0px auto" }}
                        >
                          <Accordion.Item eventKey={1}>
                            <Accordion.Header className="accordion-header fs-20">
                              Daily Top Up Limit
                            </Accordion.Header>
                            <Accordion.Collapse
                              eventKey={1}
                              className="accordion__body fs-16 text-black"
                            >
                              <div className="accordion-body text-center">
                                {/* {dailytopups} USDT /{" "} */}
                                {loadinglimit[userCard?.card_type][0]} USDT
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        </Accordion>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-3 mt-md-5">
                  <Col xl="8">
                    <div className="row">
                      <Col xl="8" sm="8" lg="6">
                        <Card>
                          {net_topup != 0 && (
                            <Card.Body
                              className="d-flex text-center"
                              style={{
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <>
                                <>
                                  <>
                                    <p className="fs-18 mb-2 text-black">
                                      {status}
                                    </p>
                                    <p className="fs-18 mb-1 text-black">
                                      Fee:{" "}
                                      {(
                                        loadingfees[
                                          localUser?.cards?.card_type
                                        ][0] * 100
                                      ).toFixed(2)}
                                      % + $
                                      {
                                        loadingfees[
                                          localUser?.cards?.card_type
                                        ][1]
                                      }
                                    </p>
                                  </>
                                  <p className="fs-18 mb-3 text-black">
                                    NET TOP UP: ${net_topup}
                                  </p>
                                </>
                                {net_topup != 0 && (
                                  <>
                                    <div className="d-flex flex-column">
                                      {success_message ? (
                                        <div
                                          className="alert alert-warning"
                                          role="alert"
                                        >
                                          Transaction Confirmed. The card
                                          balance loading can take up to 5
                                          minutes. Please be patient and do not
                                          reload this page.
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </>
                                )}
                              </>
                            </Card.Body>
                          )}
                        </Card>
                      </Col>
                    </div>
                  </Col>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardWidget;
